"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var report_card_controller_1 = __importDefault(require("./report-card.controller"));
var reportcard_html_1 = __importDefault(require("./reportcard.html"));
function getReportcard($q, ReportcardsModel, $stateParams) {
    return $q
        .all([
        ReportcardsModel.getReportcardByID($stateParams.report_card_id),
        ReportcardsModel.getSignatures($stateParams.report_card_id),
    ])
        .then(function (responses) {
        return __assign(__assign({}, responses[0].reportcard), { signatures: responses[1].signatures });
    });
}
getReportcard.$inject = ["$q", "ReportcardsModel", "$stateParams"];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.instructor.dashboard.reportcard", {
        url: "/reportcard/:report_card_id",
        controller: report_card_controller_1.default,
        controllerAs: "vm",
        template: reportcard_html_1.default,
        resolve: {
            reportcard: getReportcard,
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.parent,
                USER_ROLES.owner,
                USER_ROLES.instructor,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("instructor.dashboard.reportcard", [])
    .config(config)
    .controller("InstructorReportCard", report_card_controller_1.default);
